import React, {useState} from "react";
import "./style.css";
import {PrivacyPolicy} from "./PrivacyPolicy";
import {MONEY_BACK_POLICY, PRIVACY_POLICY, TERMS_OF_USE, FAQ} from "../../../enum/NavigationEnum";
import {TermsOfUse} from "./TermsOfUse";
import {MoneyBackPolicy} from "./MoneyBackPolicy";
import {Faq} from "./Faq";

export const Privacy = ({
                          setDisplayNav = () => {},
                          displayNav,
                            }) => {
    const [list, setList] = useState([
        {name: "Privacy Policy", value: PRIVACY_POLICY},
        {name: "Terms of Use", value: TERMS_OF_USE},
        {name: "Money Back Policy", value: MONEY_BACK_POLICY},
        {name: "FAQ", value: FAQ}
    ]);
    const [showDropdown, setShowDropdown] = useState(false);

    const renderContent = () => {
        if (displayNav === PRIVACY_POLICY) {
            return <PrivacyPolicy />
        } else if (displayNav === TERMS_OF_USE) {
            return <TermsOfUse />
        } else if (displayNav === MONEY_BACK_POLICY) {
            return <MoneyBackPolicy />
        } else if (displayNav === FAQ) {
            return <Faq />
        }
        return ;
    }
    const renderTitle = () => {
        const find = list.find(item => item.value === displayNav);
        return find ? find.name : "Privacy Policy";

    }

  return (
    <div className="privacy">
      <div className="top-nav-bar">
        <div className="frame">
          <div className="icon">
            <img className="img" alt="Icon path" src="/static/image/support/privacy/icon-path.png" onClick={() => {setDisplayNav(false)}} />
          </div>
          <img className="calo" alt="Calo" src="/static/image/support/privacy/calo.png" />
        </div>
      </div>

      <div className="frame-wrapper">
        <div className="div" onClick={() => {setShowDropdown(!showDropdown)}}>
          <div className="dropdown">{renderTitle()}</div>

          <img className="img" alt="Icon" src="/static/image/support/privacy/icon.png" style={{transform: showDropdown ? "rotate(180deg)" : ""}} />
        </div>
          {showDropdown && <div className={'frame-wrapper-dropdown'}>
              {list?.map((item, index) => {
                  return <div className={'frame-wrapper-dropdown-item'} key={index} onClick={() => {setDisplayNav(item.value);setShowDropdown(false)}}>
                      {item?.name}
                  </div>
              })}
          </div>}
      </div>

      {renderContent()}
    </div>
  );
};
